import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useProductVersionsDropDownData } from "../../../hooks/dropdown/useProductVersionsDropDownData";

export type versionsValue = {
  value: string;
  label: string;
};

type VersionFilterProps = {
  onChange: (value: any) => void;
  value?: string;
  selectedProductValue: any;
  onClear?: (value?: any) => void;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const VersionsFilter: React.FC<VersionFilterProps> = ({
  value,
  onChange,
  selectedProductValue,
  onClear,
}) => {
  const { t } = useTranslation();
  const [versions, setVersions] = useState<any>();

  const allVersions = useProductVersionsDropDownData(selectedProductValue);

  useEffect(() => {
    //console.log({ allVersions })
    if (allVersions && allVersions.status == "success") {
      setVersions(allVersions);
    }
  }, [allVersions]);

  let versionData: versionsValue[] = [];

  if (versions && versions.data) {
    for (let lsItem of versions.data.list) {
      versionData.push({
        value: lsItem.id!,
        label: lsItem.version_number!,
      });
    }
  }

  return (
    <SelectBoxWrapper>
      <Select
        // mode="multiple"
        allowClear
        placeholder={t("licenses.basic.search.version.title")}
        style={{ width: "100%" }}
        maxTagCount={1}
        options={versionData}
        onChange={(value: any, options: any) => {
          if (onChange) {
            onChange(options);
          }
        }}
        value={value}
        onClear={(value?: any) => {
          if (onClear) {
            onClear(value);
          }
        }}
      />
    </SelectBoxWrapper>
  );
};
